import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "components/app/dialog/dialog";
import { useEffect, useRef, useState } from "react";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import SearchBar from "components/app/search-bar/SearchBar";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { Button } from "components/ui/button";
import { AppRecord, AppRecordStatus } from "models/appRecord";
import { ArrowDown, X } from "lucide-react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import { profileVerified } from "assets";
import { Card } from "components/ui/card";
import { t } from "i18next";
import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "components/ui/alert-dialog";

import { BrowserDeviceInfo, convertDeviceInfoToMap, getBrowserDeviceInfo } from "utils/deviceInfo";
import InputHideShow from "components/app/function/InputHideShow";
import { updateAuthToken } from "store/authSlice";
import { useDispatch } from "react-redux";
import { setIsDialogSeeMorePagesOpen } from "store/header";

export default function DialogSeeMorePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userAccount, setUserAccount] = useState<any>(null);

  const { userAuth, token } = useAppSelector((state) => state.auth);
  const { isDialogSeeMorePagesOpen } = useAppSelector((state) => state.header);

  const [showMessage, setShowMessage] = useState(false);
  const [searchText, setSearchText] = useState<string>("");
  const [userDataClick, setUserDataClick] = useState<any>({});
  const [password, setPassword] = useState<string>("");
  const [isAlertTypingPassword, setIsAlertTypingPassword] = useState<boolean>(false);
  const [deviceInfo, setDeviceInfo] = useState<BrowserDeviceInfo | null>(null);
  const [loadingMoreItem, setLoadingMoreItem] = useState<any>(null);
  const [isLoading, setLoading] = useState<boolean>(false);
  const seeMoreLoadingState = useRef<any>(null);

  let seeMorePageState: AppRecord = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };

  const fetchMoreGetSwitchAccount = async ({ next }: { next: string }) => {
    seeMoreLoadingState.current = {
      ...seeMorePageState,
      loadingStatus: AppRecordStatus.loadingMore,
    };

    await RequestApi(next).then((responses) => {
      if (responses.status === "success") {
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: responses["users"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: responses["users"]["next_page_url"] !== null ? AppRecordStatus.noLoadMore : AppRecordStatus.loaded,
        };

        const tmpPosts = [...userAccount["data"], ...responses["users"]["data"]];

        const newPost = { ...userAccount, data: tmpPosts };
        setUserAccount(newPost);
        seeMoreLoadingState.current = stateRecord;
      }
    });
  };

  const fetchGetSwitchAccount = async () => {
    try {
      let url: string = "";
      url = userAuth ? RouteApi.getUserUser : "";
      url += `token=${token}`;

      const data = {
        search_text: searchText,
      };

      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            const stateRecord: AppRecord = {
              currentPage: 1,
              currentIndex: 0,
              nextPageUrl: responses["users"]["next_page_url"] ?? "",
              totalRecord: 0,
              loadingStatus: responses["users"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
            };

            const storeUsers = localStorage.getItem("users");
            const users = JSON.parse(storeUsers ?? "[]") ?? [];
            const perSonalUser = [];
            const responseUser = responses["users"]["data"];
            for (const storeUser of users) {
              if (storeUser["user_type"] === "Personal") {
                perSonalUser.push(storeUser);
              }
            }
            const tmpUser = [...perSonalUser, ...responseUser];
            const newUser = { ...responses["users"], data: tmpUser };
            setUserAccount(newUser);
            seeMoreLoadingState.current = stateRecord;
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[fetchGetSwitchAccount]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [messageError, setMessageError] = useState<any>("");

  const onSubmit = async ({ user }: { user: any }) => {
    setLoading(true);
    setLoadingMoreItem(user.id);
    setIsLoadingSwitchPages(true);

    try {
      let data;
      let url: string = "";
      // Personal
      if (user.user_type === "Personal") {
        url = RouteApi.switchLogin;
        url += `token=${token}&username=${user.email}&password=${password}`;

        data = {
          device_data: deviceInfo === null ? "" : convertDeviceInfoToMap(deviceInfo!),
        };
      } else if (user.user_type === "Page") {
        url = RouteApi.switchAccount;
        url += `token=${token}`;

        data = {
          user,
          device_data: deviceInfo === null ? "" : convertDeviceInfoToMap(deviceInfo!),
        };
      }

      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            setLoading(false);
            const { token, user } = responses;
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem("jwt", token);
            localStorage.setItem("authentication_key", user["authentication_key"]);
            dispatch(updateAuthToken(token));
            // navigate("/");
            window.location.href = "/";
          } else {
            setIsLoadingSwitchPages(false);
            setMessageError(responses.msg);
            setLoading(false);
          }
        })
        .catch((error) => {
          setMessageError(error);
          AppLog.show({
            message: `[onSubmit]`,
            status: StatusMsg.error,
            error,
          });
        });
    } catch (error) {
      AppLog.show({
        message: `[onSubmit]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingMoreItem(null);
    }
  };

  const handleClickSwitchAccount = ({ user }: { user: any }) => {
    if (userAuth.account_id !== user.account_id) {
      setUserDataClick(user);
      if (user.user_type === "Personal") {
        setIsAlertTypingPassword(true);
      } else if (user.user_type === "Page") {
        setIsLoadingSwitchPages(true);
        dispatch(setIsDialogSeeMorePagesOpen(false));
        onSubmit({ user });
      }
    } else {
      dispatch(setIsDialogSeeMorePagesOpen(false));
      navigate(`/profile?id=${user.id}&feed`);
      // toast.warning("You're currently logged in as this user");
    }
  };
  const handleClickPersonalSubmitForm = () => {
    onSubmit({ user: userDataClick });
  };

  useEffect(() => {
    if (searchText === "") {
      fetchGetSwitchAccount();
    } else {
      fetchGetSwitchAccount();
    }
    // eslint-disable-next-line
  }, [searchText]);

  useEffect(() => {
    setDeviceInfo(getBrowserDeviceInfo());
  }, []);

  useEffect(() => {
    if (seeMoreLoadingState.current?.nextPageUrl === "") {
      const timer = setTimeout(() => {
        setShowMessage(true);
      }, 1000);
      return () => clearTimeout(timer); // Cleanup to avoid memory leaks
    } else {
      setShowMessage(false);
    }
  }, [seeMoreLoadingState.current?.nextPageUrl]);
  const [isLaodingSwitchPages, setIsLoadingSwitchPages] = useState<boolean>(false);
  const [hideMessage, setHideMessage] = useState<boolean>(false);
  return (
    <>
      <Dialog open={isDialogSeeMorePagesOpen}>
        <DialogContent isShowBtnXClose={false} className="z-50 max-w-[300px] md:max-w-[500px] lg:max-w-[700px]">
          <DialogHeader>
            <DialogTitle>{t("Switch Accounts")}</DialogTitle>
            <DialogDescription>Quickly switch between multiple accounts without logging out.</DialogDescription>
            <div
              className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full dark:bg-background dark:hover:bg-slate-900 w-[28px] h-[28px]"
              onClick={() => dispatch(setIsDialogSeeMorePagesOpen(false))}
            >
              <X />
            </div>
          </DialogHeader>
          <div>
            <div className="mt-4">
              <SearchBar name="SearhAccount" onValueChange={(result) => setSearchText(result)} />
            </div>
            <div className="h-[400px] max-w-[300px] md:max-w-[500px] lg:max-w-[700px] mt-4">
              {userAccount ? (
                <div id="scrollableDiv" className="h-[400px] overflow-y-auto custom-scrollbar">
                  <InfiniteScroll
                    className={`relative h-[400px]`}
                    dataLength={userAccount["data"]?.length}
                    next={() =>
                      fetchMoreGetSwitchAccount({
                        next: seeMoreLoadingState.current.nextPageUrl,
                      })
                    }
                    scrollThreshold="90%"
                    hasMore={seeMoreLoadingState.current.nextPageUrl === "" ? false : true}
                    scrollableTarget="scrollableDiv"
                    loader={
                      <div className="absolute bottom-2 left-0 w-full flex justify-center">
                        {/* <LoaderCircle
                        size={30}
                        className="animate-spin text-yellow-400"
                      /> */}
                      </div>
                    }
                    endMessage={
                      <>
                        {showMessage && (
                          <p className="absolute bottom-0 left-0 w-full text-center">
                            <b>Nothing more to load!</b>
                          </p>
                        )}
                      </>
                    }
                  >
                    <div onWheel={(e) => e.stopPropagation()} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-20">
                      {userAccount?.data?.map((user: any) => {
                        return (
                          <Card key={user.id} className="rounded-md space-y-2">
                            <div
                              className="cursor-pointer relative overflow-hidden"
                              onClick={() => {
                                dispatch(setIsDialogSeeMorePagesOpen(false));
                                navigate(`/profile?id=${user?.id}&feed`);
                              }}
                            >
                              {user.status === "Unpublished" && (
                                <div className="absolute z-10 top-0 rounded-bl-md rounded-tr-md  right-0 bg-red-700 p-2 text-white text-center font-sans py-0.5 opacity-80 flex items-center">
                                  <span className="text-sm">{user.status}</span>
                                </div>
                              )}

                              <ImageUrlProfile className="w-full object-cover h-[200px] rounded-t-md" user={user} isThumbnail={false} />
                              {/* Name */}
                              <div className="p-2">
                                <div className="flex">
                                  <h1 className="font-semibold text-lg line-clamp-1">{user?.name}</h1>
                                  {user?.is_verified === "Yes" ? (
                                    <div>
                                      <div className="flex items-center justify-center pt-0.5 ml-1">
                                        <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <p className={`line-clamp-1 h-[25px] ${user?.bio === "" ? "invisible" : ""}`}>{user?.bio !== "" ? user?.bio : "NoBio"}</p>
                              </div>
                            </div>

                            {/* Follower Post Like */}
                            <div className="grid grid-cols-3 text-center">
                              <div className="">
                                <h1 className="font-semibold">{user?.no_of_follower}</h1>
                                <p className="text-xs">Followers</p>
                              </div>
                              <div className="">
                                <h1 className="font-semibold">{user?.no_of_post}</h1>
                                <p className="text-xs">Posts</p>
                              </div>
                              <div className="">
                                <h1 className="font-semibold">{user?.no_of_like}</h1>
                                <p className="text-xs">Likes</p>
                              </div>
                            </div>
                            {userAuth.account_id !== user.account_id ? (
                              <div className="grid grid-cols-1 p-2">
                                <Button
                                  onClick={() => {
                                    handleClickSwitchAccount({ user });
                                    dispatch(setIsDialogSeeMorePagesOpen(false));
                                  }}
                                  size={"sm"}
                                  className={`text-white `}
                                  disabled={loadingMoreItem === user.id}
                                >
                                  Switch Account
                                </Button>
                              </div>
                            ) : (
                              ""
                            )}
                          </Card>
                        );
                      })}
                    </div>
                  </InfiniteScroll>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <AlertDialog open={isAlertTypingPassword}>
        <form>
          <AlertDialogContent>
            <AlertDialogHeader className="relative">
              <AlertDialogTitle></AlertDialogTitle>
              <X
                onClick={() => {
                  setIsAlertTypingPassword(false);
                  setMessageError("");
                }}
                className="absolute top-0 right-0 cursor-pointer"
              />
            </AlertDialogHeader>
            <div className="flex justify-center items-center flex-col space-y-2">
              <ImageUrlProfile className="rounded-full w-[100px] h-[100px]" user={userDataClick} />
              <p className="font-semibold text-xl">{userDataClick.name}</p>
              <p className=" text-sm pb-10 ">{userDataClick.bio}</p>
              <div className="w-full mt-2">
                <InputHideShow
                  placeholder="Password"
                  onChange={(event) => {
                    setPassword(event.target.value);
                    setMessageError("");
                  }}
                />
              </div>
              {messageError && <p className="text-red-500 text-start">{messageError}</p>}
              {/* {hideMessage && (
                <p className="text-red-500 text-start">{messageError}</p>
              )} */}
            </div>
            <AlertDialogFooter>
              <AlertDialogAction
                onClick={() => {
                  handleClickPersonalSubmitForm();
                }}
                className="text-white w-full"
              >
                Continue
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </form>
      </AlertDialog>
      <AlertDialog open={isLaodingSwitchPages}>
        <form>
          <AlertDialogContent>
            <AlertDialogHeader className="relative">
              <AlertDialogTitle></AlertDialogTitle>
            </AlertDialogHeader>
            <div className="flex justify-center items-center flex-col space-y-2">
              <ImageUrlProfile className="rounded-full w-[100px] h-[100px]" user={userDataClick} />
              <p className="font-semibold text-xl">{userDataClick.name}</p>
              <p className=" text-sm pb-10 ">{userDataClick.bio}</p>
              <svg className="size-6 animate-bounce ">
                <ArrowDown className=" font-semibold" />
              </svg>
              <p className=" text-sm font-semibold pb-10 ">{userDataClick.user_type === "Personal" ? " Switching Account..." : "Switching Page..."}</p>
            </div>
          </AlertDialogContent>
        </form>
      </AlertDialog>
    </>
  );
}
